import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import JisDialogForm from "../../components/formdialog";
import JisTabButton from "../../components/controls/jisTabButton";
import DeadlineBadge from "../../components/controls/deadlinebadge";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import useComments from "../../hooks/useComment";

import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";
import moment from "moment";
import PdfViewer from "../../components/controls/pdfviewer";

// Move CommentDropdown outside to prevent re-creation on every render
const CommentDropdown = ({
  setNewValue,
  onChange,
  name,
  placeholder,
  required,
  reasonPlaceHolder,
  initialValue = "",
  predefinedComments = [],
}) => {
  const [selectedComments, setSelectedComments] = useState([]);
  const [value, setValue] = useState(initialValue);

  // Reset value when initialValue changes (e.g., when modal opens)
  useEffect(() => {
    setValue(initialValue);
    setSelectedComments([]);
  }, [initialValue]);

  // Load predefined selections from value
  useEffect(() => {
    if (value && predefinedComments.length > 0) {
      const parts = value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);

      const predefinedSelected = parts.filter((p) =>
        predefinedComments.some((comment) =>
          typeof comment === "string" ? comment === p : comment.source === p
        )
      );

      setSelectedComments(predefinedSelected);
    }
  }, [value, predefinedComments]);

  // Update parent component - works with both setValue and onChange patterns
  const updateParent = (finalValue) => {
    if (setNewValue) {
      setNewValue(finalValue);
    }
    if (onChange) {
      onChange({ target: { name, value: finalValue } });
    }
  };

  // Merge and update the parent
  const updateFinal = (updatedSelected, customText) => {
    const cleanedCustom = customText.split(",").map((v) => v.trim());

    const finalValue = [...updatedSelected, ...cleanedCustom]
      .filter(Boolean)
      .join(", ");

    updateParent(finalValue);
  };

  // Handle checkbox change
  const handleCheckboxChange = (e) => {
    const { checked, value: comment } = e.target;

    const updatedSelected = checked
      ? [...selectedComments, comment]
      : selectedComments.filter((c) => c !== comment);

    setSelectedComments(updatedSelected);

    // Get current custom text (non-predefined parts)
    const currentParts = (value || "")
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    const customOnly = currentParts.filter(
      (p) =>
        !predefinedComments.some((comment) =>
          typeof comment === "string" ? comment === p : comment.source === p
        )
    );

    updateFinal(updatedSelected, customOnly.join(", "));
  };

  // Handle textarea typing
  const handleCustomChange = (e) => {
    const inputText = e.target.value;

    // Update parent immediately for responsive typing
    updateParent(inputText);

    // Update internal selected comments based on what's typed
    const parts = inputText
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    const predefinedInText = parts.filter((p) =>
      predefinedComments.some((comment) =>
        typeof comment === "string" ? comment === p : comment.source === p
      )
    );
    setSelectedComments(predefinedInText);
  };

  return (
    <div>
      {reasonPlaceHolder && (
        <p className="reason_placeholder">{reasonPlaceHolder}</p>
      )}
      <div className="predefined_comment_wrapper">
        {predefinedComments.map((comment, index) => {
          const commentText =
            typeof comment === "string" ? comment : comment.source;
          return (
            <label key={index} className="predefined_checkbox_wrapper">
              <input
                type="checkbox"
                value={commentText}
                checked={selectedComments.includes(commentText)}
                onChange={handleCheckboxChange}
              />
              <p>{commentText}</p>
            </label>
          );
        })}
      </div>

      <div>
        <label style={{ marginBottom: "120px" }} htmlFor="comments">
          comment
        </label>
        <textarea
          className="predefinedComments_textarea"
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={(e) => handleCustomChange(e)}
        />
      </div>
    </div>
  );
};

function ServiceSheriffHearingNotice() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert,holidays } =
    useContext(ShareContext);

  // Fetch predefined comments
  const { comments: predefinedComments } = useComments(token);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isLiti, setIsLitiation] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [selectedCases, setSelectedCases] = useState({});
  const [assignTo, setAssignTo] = useState(null);
  const [sheriffs, setSheriffs] = useState([]);
  const [tab, setTab] = useState("pending");
  const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
  const [locs, setLocs] = useState({ state: null, lga: null, city: null });
  const [Lga, setLga] = useState([]);
  const [states, setStates] = useState([]);
  const [lgaId, setLgaId] = useState(0);
  const [isAddService, setIsAddService] = useState(false);
  const [services, setServices] = useState([]);
  const [isDocPreview, setIsDocPreview] = useState(false);
  const [previewUrl, setPreviewUrl] =  useState(false);
  const [serveds, setServeds] = useState({});


  const [caseInfo, setCaseInfo] = useState({
    stateId: Constants.Default_State,
    processType: "Normal",
    isPublic: 1,
    caseFilingId: 1,
    isDelarative: true,
    isRequireInterpretation: true,
    isLegalPolicy: true,
    isLegalPosition: true,
    isEmergency: true,
    isDispute: true,
    isUniform: true,
  });
  console.log(Lga);
  const onGetStates = async () => {
    //for account registration
    try {
      setLocs((prevLocs) => ({ ...prevLocs, state: false }));
      const resp = await fetch(`${Constants.apiUrl}/profile/states`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setLocs((prevLocs) => ({ ...prevLocs, state: true }));
      setStates(data);
    } catch (error) {
      setLocs((prevLocs) => ({ ...prevLocs, state: null }));
      console.error(error);
    }
  };

  useEffect(() => {
    //onLoad();
    onLoadSheriffByDivision();
  }, []);

  useEffect(() => {
    if (search != null && lgaId !== null) {
      if (pageIndex >= 0) {
        console.log(
          "loding from direct useEffect with pageIndex,pageSize,search"
        );
        console.log(`is search ${isSearch}`);
        onSearch(search);
      } else {
        setPageIndex(0);
      }
    }
  }, [pageIndex, pageSize, search, tab, lgaId]);

  useEffect(() => {
    var cc = localStorage.getItem("caseinfo");
    if (cc != null) {
      var all = JSON.parse(cc);
      //{cinfo,selectedCauses,otherCauses,fiat,claims}
      setCaseInfo(all.caseInfo);
    }
    onGetStates();
  }, []);

 useEffect(() => {
      if (isPreview && active != null) {
        //load the parties to the case
       
        onLoadDocuments();
      }
    }, [active, isPreview]);

  useEffect(() => {
    console.log(
      selected[Array.from(Object.keys(selected))[0]],
      "selected case"
    );
    console.log(Array.from(selected));
    console.log(selectedCases, "selectedCase case");
  }, [selectedCases, selected]);

  useEffect(() => {
    onGetLgs();
  }, []);

  console.log(locs);

  const onLoadSheriffByDivision = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/get-Service-Sheriff`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setSheriffs(data.pros);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

const closePreview=()=>{
  setIsPreview(false);
  setIndex(-1);
}
  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/service-sheriff-notice/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      setIsSearch(true);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    navigate(`/case-details/${fee.caseId}`);
    // setActive(fee);
    // setIndex(ind);
    // setOpenCase(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
  };

  const onGetLgs = async () => {
    //for account registration
    try {
      setLocs((prevLocs) => ({ ...prevLocs, lga: false }));
      const resp = await fetch(`${Constants.apiUrl}/profile/lgs/15`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setLga(data);
      setLocs((prevLocs) => ({ ...prevLocs, lga: true }));
    } catch (error) {
      setLocs((prevLocs) => ({ ...prevLocs, lga: null }));
      console.error(error);
    }
  };

   const onAddService = (kase, ind) => {
        
        setActive(kase);
        setIndex(ind);
        setIsPreview(true);
      };

     const onLoadDocuments = async () => {
          //for account registration
          try {
            setLoading(true);
            const resp = await fetch(
              `${Constants.apiUrl}/hearing/load-hearing-documents/${active.id}/${active.caseId}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            const data = await resp.json();
            setLoading(false);
            if (data.code == 0) {
              setServices(data.services);
            } else if (data.code == -10) {
              setIsExpired(true);
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
          }
        };
   const onDownload= async(doc)=>{ //doctype=upline always this one
    //for account registration DocumentView
    const url=`${Constants.apiUrl}/filing/download-docupload-line/${doc.id}`

    console.log(`the calling url ${url}`);
    try {
        setLoading(true);
        const resp = await fetch(url, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'responseType': 'blob'
          },
        });
        
        const data = await resp.blob();
        setLoading(false);
        console.log('specific document');
        const blob = new Blob([data], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.download =doc.filename;// 'some.pdf';
            link.href = URL.createObjectURL(blob);
            link.click();
      } catch (error) {
        setLoading(false);
        console.error(error);
        
      }
}
const onPreviewDoc =(docs)=>{
        setIsDocPreview(true);
      console.log(docs);
        console.log('here is called');
        var finalpath='';
                if(docs.filename!=null){
                  finalpath= Constants.RelativeFiletoRelative(`${docs.filename}`  );
                }else{
                   finalpath=`${Constants.baseurl}/template-document/${docs.id}`
                }
        setPreviewUrl(finalpath )

    }

  return (
    <div>
      {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader onSearch={onSearch} frequentData={frequentData} />


      <div className="tab_body">
        <div className="exportdiv">
          <img
            src={wordicon}
            // onClick={() => onExport("word")}
            style={{ cursor: "pointer" }}
          />
          <img
            src={excelicon}
            // onClick={() => onExport("excel")}
            style={{ cursor: "pointer" }}
          />
          <img
            src={pdficon}
            // onClick={() => onExport("pdf")}
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="case-assignment-tab-container">
          <div className="tab_section">
            <JisTabButton
              isActive={tab == "pending"}
              title="Pending Cases"
              isRoleBased={false}
              onClick={() => setTab("pending")}
            />
            <JisTabButton
              isActive={tab == "served"}
              title="Served Cases"
              isRoleBased={false}
              onClick={() => {
                setTab("served");
                setSelected(new Set());
                setSelectedCases({});
              }}
            />
           
          </div>

      
        </div>

        <div className="tab_view">
            {cases?.length == 0 && <JisEmptyList />}
            {cases?.length > 0 && (
              <div className="table">
                <div class="section-cases">
                  <span>Unschedule Cases</span>
                </div>
                <table class="case-table">
                  <thead>
                    <tr>
                      <th className="col-title">Suit Number</th>
                      <th className="col-title">Case Title</th>
                      <th className="col-medium">Filing Type</th>
                      <th className="col-medium">Classification</th>
                      <th className="col-medium">Case Age(Days)</th>
                      <th className="col-medium">Date Initiated</th>
                      <th className="col-medium">Status Level</th>
                      <th className="col-medium">Schedule Date</th>
                      <th className="col-title">Details</th>
                      <th className="col-action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cases?.map((opt, index) => {
                      const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                      return (
                        <tr key={index}>
                          <td style={{
                            backgroundColor: `${
                              Constants.getItemById(
                                frequentData?.casecategories,
                                opt.case?.caseCategoryId
                              )?.colour
                            }`,
                          }}>{opt.case?.caseNumber || "N/A"}</td>
                          <td>{opt.case?.caseTitle || "N/A"}</td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casetype,
                              opt.case?.caseTypeId
                            )?.caseType1 || "N/A"}
                          </td>
                          <td>
                            {" "}
                            {Constants.getItemById(
                              frequentData?.casecategories,
                              opt.case?.caseCategoryId
                            )?.categoryTitle || "N/A"}
                          </td>
                          <td>
                            {moment().diff(opt.createdOn, "days") || "N/A"}
                          </td>
                          <td>
                            {Constants.momentDate(opt.case?.createdOn).format(
                              "DD MMM, YYYY"
                            ) || "N/A"}
                          </td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casestatuses,
                              opt.case?.caseStatusId
                            )?.description || "N/A"}
                          </td>
                          <td>
                            {Constants.momentDate(opt.scheduleDate).format(
                              "DD MMM, YYYY"
                            ) || "N/A"}
                          </td>
                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onContinue(opt.case, index)}
                            >
                              View
                            </JisButton>
                          </td>
                          <td>
                            
                              <JisButton
                                variant="plain"
                                 onClick={() => onAddService(opt, index)}>
                                See Notice
                              </JisButton>
                           
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {cases?.length > 0 && (
                  <Pagenated
                    onChangePageSize={(k) => setPageSize(k)}
                    size={pageSize}
                    total={count}
                    maxPage={20}
                    onPick={onPagePick}
                  />
                )}
              </div>
            )}
          </div>
      </div>

      <BackLoader open={loading} />

      {openCase && active != null && (
        <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}
{isPreview && <div className={  "preview open" } style={{overflow:'scroll'}}>
                <div className="heading">
                  <div className='buttongroup'>
                    <JisButton icon="close"  onClick={closePreview}> Close</JisButton>
                     </div>
                  <div className='panel'>
                    <div className='title'>Hearing Notice to Serve {services?.length}</div>
                    <div className='panel-body'>
                         {services?.map((opt,index) => (
                           <div key={index}>
                              <div>{opt.party.firstName} {opt.party.lastname??''}</div>
                              <div>{opt.documentLocation!="template"? <div className='schedule-zoom' onClick={() => onDownload(opt?.line) }> Download <DynamicIcon iname='download' /> </div>
                                      : <div className='schedule-zoom'>  <Link target='_blank' to={`/template-live-document/${opt?.line?.id}`}>Print/Save <DynamicIcon iname='print' /> </Link></div>}</div>
                                      <div><JisButton onClick={()=>onPreviewDoc(opt?.line)}>Preview</JisButton></div>
                              {/* <div>
                                <div className="input-group">
                          <div className="input-wrapper">
                            <DynamicIcon iname="person_3" />
                            <input
                              placeholder="Served On"
                              type="date"
                              value={servedon}
                              onChange={(e) => setServedOn(e.target.value)}
                            />
                          </div>
                        </div>
                        </div>   */}      
                           </div>
                          ))}
                    </div>
                    </div>     
                </div>
            </div>} 
{isDocPreview && previewUrl!='' && <JisDialogForm title="Document Preview" onClose={() =>setIsDocPreview(false)}>
          <div>
            <div style={{height:'90vh'}}> <PdfViewer pdfUrl={previewUrl}/>
                               
                                </div>
          </div>
</JisDialogForm>} 
  
    </div>
  );
}

export default ServiceSheriffHearingNotice;
